import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

(function ($) {
  $(function () {
    $(".hero-v2__swiper").each(function () {
      var $slides = $(this).find(".swiper-slide");
      var swiper = new Swiper($(this).get(0), {
        modules: [Pagination, Autoplay, EffectFade],
        spaceBetween: 30,
        slidesPerView: 1,
        loop: $slides.length > 1,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false
        // },
        effect: "fade",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });

      // Add transition class for active slide
      updateTransition(swiper);
      swiper.on("slideChangeTransitionEnd", function () {
        updateTransition(this);
      });
    });

    $(".references__swiper").each(function () {
      var $swiper = $(this);

      var swiper = new Swiper($swiper.get(0), {
        modules: [Navigation, Autoplay, EffectFade],
        spaceBetween: 30,
        slidesPerView: 1,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        effect: "fade",
        navigation: {
          nextEl: ".references__next",
          prevEl: ".references__prev",
        },
      });
    });

    $(".job-swiper").each(function () {
      var $swiper = $(this);

      var swiper = new Swiper($swiper.get(0), {
        modules: [Navigation, Autoplay, EffectFade],
        spaceBetween: 30,
        slidesPerView: 1,
        loop: true,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        effect: "fade",
        navigation: {
          nextEl: ".job-next",
          prevEl: ".job-prev",
        },
      });
    });

    var swiper = new Swiper(".news__swiper", {
      modules: [Navigation],
      spaceBetween: 30,
      slidesPerView: 1,
      // autoHeight: true,
      navigation: {
        nextEl: ".news__next",
        prevEl: ".news__prev",
      },
      pagination: {
        el: ".news__pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 50,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
      },
    });
  });

  function updateTransition(instance) {
    var $activeSlide = $(".hero-v2 .swiper-slide-active");
    $activeSlide.addClass("swiper-slide--animate");
    $(".swiper-slide--animate")
      .not($activeSlide)
      .removeClass("swiper-slide--animate");
  }
})(jQuery);
